import React from "react";
import ShowOfferLetter from "../OfferLetter/ShowOfferLetter";

const ShowAppointmentLetter = () => {
  return (
    <ShowOfferLetter
      letterLabel="Appointment Letter"
      backToListRoute="/user_dashboard/appointment-letters"
      letterType="appointment"
    />
  );
};

export default ShowAppointmentLetter;
